<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="['SlideWithImage', 'theme-base-bg-color', 'flex', 'justify-center', 'items-center', 'slide', contents.image.position === 'left' ? 'left-image row-reverse-tablet' : 'right-image']" :style="contents.bg.isCustom ? 'background-color:' + contents.bg.color : ''">
            <div class="slide-content flex column justify-center">
              <h2 class="slide-h2">{{ contents.heading.text }}</h2>
              <p class="slide-p pre-wrap">{{ contents.paragraph.text }}</p>
              <template v-if="contents.list && contents.list.length > 0 && contents.list.reduce((p, c) => p + c, '') !== ''">
                <ul class="slide-list">
                  <template v-for="(item, index) in contents.list">
                    <li class="slide-item" :key="index">{{ item }}</li>
                  </template>
                </ul>
              </template>
              <template v-if="contents.link.text && contents.link.href">
                <a :class="['slide-button', contents.link.form + '-button']">{{ contents.link.text }}</a>
              </template>
            </div>
            <div :class="['amp-img', 'slide-img', 'amp-img-cover', contents.image.width > contents.image.height ? 'landscape' : 'portrait']">
              <mimic-amp-img :image="contents.image"></mimic-amp-img>
            </div>
          </section>

        </div>
      </div>

      <el-dialog width="90%" title="画像の選択" :visible.sync="dialogFormVisible">
        <select-image v-model="selectedImage" @change="onUpdateImage"></select-image>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">キャンセル</el-button>
          <el-button type="primary" @click="onUpdateImage">選択</el-button>
        </span>
      </el-dialog>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="見出し" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.heading.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="段落" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.paragraph.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="リスト" :label-width="labelWidth">
          <el-input type="input" class="width-75" v-model="contents.list[index]" auto-complete="off" v-for="(item, index) in contents.list" :key="index">
              <el-button slot="append" icon="el-icon-delete" @click="contents.list.splice(index, 1)"></el-button>
          </el-input>
        </el-form-item>
        <el-button :style="'margin:0 0 30px ' + labelWidth" @click="contents.list.push('')">リスト項目の追加</el-button>
        <el-form-item label="リンクテキスト" :label-width="labelWidth">
          <el-input class="width-75" v-model="contents.link.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="リンク先URL" :label-width="labelWidth">
          <el-input class="width-75" v-model="contents.link.href" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="リンクボタンの形状" :label-width="labelWidth">
          <el-radio-group v-model="contents.link.form">
            <el-radio-button :disabled="contents.link.text === '' || contents.link.href === ''" label="round">楕円ボタン</el-radio-button>
            <el-radio-button :disabled="contents.link.text === '' || contents.link.href === ''" label="square">四角ボタン</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-button @click="onSelectImage(contents.image)">画像の選択</el-button>
        <div class="image-info flex column justify-between items-center">
          <img class="image-info-img" :src="contents.image.src">
          <p class="image-info-size">画像のサイズ：{{ contents.image.width }}x{{ contents.image.height }}</p>
        </div>
        <el-form-item label="画像の配置場所" :label-width="labelWidth">
          <el-radio-group v-model="contents.image.position">
            <el-radio-button label="left"></el-radio-button>
            <el-radio-button label="right"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import SelectImage from '@/components/app/SelectImage'

export default {
  name: 'slide-with-image',
  components: {
    'mimic-amp-img': MimicAmpImg,
    'select-image': SelectImage
  },
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '11em',
      selectedImage: {
        id: null,
        src: null,
        width: null,
        height: null
      },
      dialogFormVisible: false
    }
  },
  watch: {
    selectedImage: function (newVal) {
      console.log(newVal)
    }
  },
  methods: {
    /**
     * 「画像の選択」ボタンがクリックされたら、contents.imageの各プロパティを
     * this.selectedImageにコピーする
     */
    onSelectImage: function (image) {
      const found = this.media.find(img => img.source_url === image.src)
      if (process.env.NODE_ENV !== 'production') console.log(found)
      image.id = found ? found.id : 0

      this.selectedImage.id = image.id
      this.selectedImage.src = image.src
      this.selectedImage.width = image.width
      this.selectedImage.height = image.height
      this.dialogFormVisible = true
    },
    /**
     * ダイアログで画像を選択したら、選択した画像をidを元にthis.mediaから探し、
     * その画像の情報をthis.contents.imageに格納する
     */
    onUpdateImage: function () {
      const selected = this.media.find(image => image.id === this.selectedImage.id)
      this.contents.image.id = selected.id
      this.contents.image.src = selected.source_url
      this.contents.image.width = selected.media_details.width
      this.contents.image.height = selected.media_details.height
      this.dialogFormVisible = false
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      let ul = ''
      if (contents.list && contents.list.length > 0 && contents.list.reduce((p, c) => p + c, '')) {
        ul += '<ul class="slide-list">'
        contents.list.forEach(item => {
          ul += `<li class="slide-item">${item}</li>`
        })
        ul += '</ul>'
      }
      let anchor = ''
      if (contents.link.text && contents.link.href) {
        anchor += `<a class="slide-button ${contents.link.form}-button" href="${contents.link.href}">${contents.link.text}</a>`
      }
      const imageDirection = contents.image.width > contents.image.height ? 'landscape' : 'portrait'

      const imagePlace = contents.image.position === 'left' ? 'left-image row-reverse-tablet' : 'right-image'

      const html = `
        <section id="${this.sectionId}" class="${this.meta.file} flex column row-tablet justify-center items-center slide ${imagePlace} ${contents.bg.isCustom ? `${this.meta.file}-${this._uid}-bg` : 'theme-base-bg-color'}">
          <div class="slide-content flex column justify-center">
            <h2 class="slide-h2">${contents.heading.text}</h2>
            <p class="slide-p pre-wrap">${contents.paragraph.text}</p>
            ${ul}
            ${anchor}
          </div>
          <amp-img class="slide-img amp-img-cover ${imageDirection}" width="${contents.image.width}" height="${contents.image.height}" layout="responsive" src="${contents.image.src}"></amp-img>
        </section>`

      return html.replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import './SlideWithImage.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './SlideWithImage.s.scss';
}
.tablet,
.desktop {
  @import './SlideWithImage.m.scss';
}
.desktop {
  @import './SlideWithImage.l.scss';
}
</style>


// WEBPACK FOOTER //
// src/components/contents/SlideWithImage/SlideWithImage.vue